<app-resume-parsing-state [initialParsingState]="model.resumeParsingStatus" (parsingCompleted)="onParsingCompleted($event)"></app-resume-parsing-state>
<form #profileForm="ngForm" novalidate>
  <div class="row">
    <div class="col-12">
      <div class="box">
        <h2>Profile</h2>
        <div class="formBody pt-2">
          <div class="row">
            <div class="col-md-2 text-center profilePicContainer" style="display:none">
              <div class="profilePic">
                <img src="/dist/assets/noun_User.png">
                <i class="fa fa-pencil"></i>
              </div>
              <h3>Joe Hair</h3>
              <p>UI/UX/IA Consultant</p>
            </div>
            <div class="col-md-12 pl-2">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">First Name</label>
                    <input name="firstName" mdbInput type="text" class="form-control" disabled [(ngModel)]="model.profile.firstName" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">Last Name</label>
                    <input name="lastName" mdbInput type="text" class="form-control" disabled [(ngModel)]="model.profile.lastName" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">Email</label>
                    <input name="emailAddress" mdbInput type="text" class="form-control" disabled [(ngModel)]="model.profile.emailAddress" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required" for="mobilePhone">Mobile Phone</label>
                    <input #mobilePhone="ngModel" id="mobilePhone" name="mobilePhone" mdbInput mdbValidate type="tel"
                           required minlength="10" [textMask]="{mask: phoneMask}"
                           class="form-control" [(ngModel)]="model.profile.mobilePhone"
                           (ngModelChange)="model.profile.mobilePhone = unmaskPhoneNumber($event)" />
                    <mdb-error *ngIf="mobilePhone.invalid && (mobilePhone.dirty || mobilePhone.touched)">Mobile Phone is required in the form XXX-XXX-XXXX.</mdb-error>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required" for="address">Address</label>
                    <input #address="ngModel" id="address" name="address" mdbInput mdbValidate type="text" required
                           class="form-control" [(ngModel)]="model.profile.address" />
                    <mdb-error *ngIf="address.invalid && (address.dirty || address.touched)">Address is required.</mdb-error>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label class="required" for="city">City</label>
                    <input #city="ngModel" id="city" name="city" mdbInput mdbValidate type="text" required
                           class="form-control" [(ngModel)]="model.profile.city" />
                    <mdb-error *ngIf="city.invalid && (city.dirty || city.touched)">City is required.</mdb-error>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group mdSelect stateSelect">
                    <label class="state-label" for="province">State</label>
                    <ng-select #province="ngModel" id="province" name="province" #p="ngModel" [items]="provinces" [clearable]="false" class="hideCursor"
                               [searchFn]="startsWithSearchFn" placeholder="Select State..." [(ngModel)]="model.profile.province" required></ng-select>
                    <mdb-error *ngIf="province.invalid && (province.dirty || province.touched)">State is required.</mdb-error>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label class="required" for="postalCode">Zip</label>
                    <input #postalCode="ngModel" id="postalCode" name="postalCode" mdbInput mdbValidate type="text"
                           required maxlength="10" pattern="(^(?!0{5})(\d{5})(?!-?0{4})(|-\d{4})?$)"
                           class="form-control" [(ngModel)]="model.profile.postalCode" />
                    <mdb-error *ngIf="postalCode.invalid && (postalCode.dirty || postalCode.touched)">5 digits required (extension optional).</mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="box">
            <h2>Additional Information</h2>
            <div class="row mt-3">
              <div class="col-12">
                Were you referred to this job by one of our employees? <span class="text-danger">*</span>
              </div>
              <div class="form-group">
                <div class="col-12 mt-2">
                  <input type="radio" id="isEmployeeReferralYes" name="isEmployeeReferral" class="form-check-input"
                         [(ngModel)]="isEmployeeReferral" [value]="true" mdbInput data-success=" " required />
                  <label class="form-check-label" for="isEmployeeReferralYes">Yes</label>
                </div>
                <div class="col-12">
                  <input type="radio" id="isEmployeeReferralNo" name="isEmployeeReferral" class="form-check-input"
                         [(ngModel)]="isEmployeeReferral" [value]="false" mdbInput data-success=" " required />
                  <label class="form-check-label" for="isEmployeeReferralNo">No</label>
                </div>
                <div class="col-12 mt-2" *ngIf="isEmployeeReferral">
                  <label for="referringEmployeeName">Name of referring employee <span class="text-danger">*</span></label>
                  <input id="employeeReferral" name="employeeReferral" mdbInput mdbValidate type="text" required maxlength="50" pattern=".*\S.*"
                         class="form-control" [(ngModel)]="model.profile.employeeReferral" />
                </div>
              </div>
            </div>

            <div class="row mt-3" *ngIf="model.existingEmployeeTrackingEnabled">
              <div class="col-12">
                Are you currently an employee of our organization? <span class="text-danger">*</span>
              </div>
              <div class="form-group">
                <div class="col-12 mt-2">
                  <input type="radio" id="isEmployeeYes" name="isEmployee" class="form-check-input"
                         [(ngModel)]="isExistingEmployee" [value]="true" mdbInput data-success=" " required />
                  <label class="form-check-label" for="isEmployeeYes">Yes</label>
                </div>
                <div class="col-12">
                  <input type="radio" id="isEmployeeNo" name="isEmployee" class="form-check-input"
                         [(ngModel)]="isExistingEmployee" [value]="false" mdbInput data-success=" " required />
                  <label class="form-check-label" for="isEmployeeNo">No</label>
                </div>
                <div class="col-12 mt-2" *ngIf="isExistingEmployee">
                  <label for="employeeIdentification">Employee ID / Email <span class="text-danger">*</span></label>
                  <input id="employeeIdentification" name="employeeIdentification" mdbInput mdbValidate type="text" required maxlength="500"
                         class="form-control" [(ngModel)]="model.profile.employeeIdentification" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-12 text-right">
      <button class="btn-default btn" mdbWavesEffect (click)="displayCancelModal()">Cancel</button>
      <button class="btn-outline btn" mdbWavesEffect *ngIf="canNavigateBackwards" (click)="back()">Previous</button>
      <button class="btn btn-primary mr-0" mdbWavesEffect [disabled]="!profileForm.form.valid || (phoneNumberConfirmRequired() && !confirmMobilePhoneIsValid()) || processingServerSideRequest" (click)="save()">
        <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="processingServerSideRequest"></i> Save and continue
      </button>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12 text-right">
      <a (click)="openSaveAndFinishLater()" [disabled]="processingServerSideRequest" *ngIf="saveAndFinishLaterEnabled" class="saveAndFinishLaterLink">
        Save and Finish Later
      </a>
    </div>
  </div>
</form>


<div mdbModal #cancelModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="cancel()" novalidate>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancelModal.hide()">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">Cancel Job Application</h4>
        </div>
        <div class="modal-body">
          By canceling, you will lose all data and you'll return to the open jobs page. Are you sure you want to cancel?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" aria-label="Close" (click)="cancelModal.hide()" mdbWavesEffect>No</button>
          <button type="submit" class="btn btn-primary" mdbWavesEffect>Yes</button>
        </div>
      </div>
    </form>
  </div>
</div>

<app-save-and-finish-later [open]="openSaveAndFinishLaterModal" [jobId]="jobId" [emailAddress]="model.profile.emailAddress" (saved)="saveAndFinishLater($event)" (closed)="closeSaveAndFinishLater()"></app-save-and-finish-later>
